var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageTrainersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 26.5,
    r: 26.5,
    fill: "#00AEEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7541 31.7613L20.3633 33.9813C20.3105 34.2477 20.3558 34.5242 20.4909 34.7598C20.6259 34.9954 20.8416 35.1742 21.0981 35.2633C22.3019 35.6854 23.365 36.0763 24.8971 36.7486C25.7883 37.1238 26.867 37.7335 28.6962 38.4996C29.3253 38.7267 29.9744 38.8942 30.6348 38.9999H35.325C35.5862 38.9977 35.8437 38.9366 36.078 38.821C36.3124 38.7055 36.5176 38.5386 36.6784 38.3327C36.8392 38.1268 36.9514 37.8872 37.0068 37.6319C37.0621 37.3765 37.059 37.112 36.9978 36.858L35.8722 30.7607C35.8722 27.2431 31.182 27.2431 28.8369 24.898C27.6644 23.7255 31.182 23.7255 31.182 17.8627C31.182 13.9542 29.6186 12 26.4918 12C23.365 12 21.8016 13.9542 21.8016 17.8627C21.8016 23.7255 25.3193 23.7255 24.1467 24.898C21.8016 27.2431 17.1114 27.2431 17.1114 30.7607L16.0483 36.858C15.9871 37.112 15.984 37.3765 16.0393 37.6319C16.0946 37.8872 16.2069 38.1268 16.3677 38.3327C16.5285 38.5386 16.7338 38.7055 16.9681 38.821C17.2025 38.9366 17.4599 38.9977 17.7211 38.9999H25.4131C25.7111 39.0038 26.004 38.9224 26.2573 38.7653L27.2579 38.1556",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1669 31.7617L32.6828 34.3882C31.1246 34.5455 29.5586 34.6133 27.9926 34.5915C24.8658 34.5915 21.8485 34.6853 20.4102 34.5915",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageTrainersIcon);
export default __webpack_public_path__ + "static/media/manage-trainers-icon.dd214c2c542d137ea27047b6f05041d6.svg";
export { ForwardRef as ReactComponent };